import { z } from 'zod'

/**
 * GET /api/v2/master/update/check
 * 前回リクエスト以降に更新されたマスターテーブルを返す。
 * update の各キーは true = 更新あり（フロントは対応 API を再フェッチする）。
 */
export const MasterUpdateCheckResponseSchema = z.object({
  update: z
    .record(z.string(), z.boolean())
    .describe('各マスターテーブルの更新有無（true = 更新あり、フロントは対応 API を再フェッチする）'),
})

export type MasterUpdateCheckResponse = z.infer<typeof MasterUpdateCheckResponseSchema>
